import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import styled from 'styled-components'
import { Colors, Fonts, Metrics } from '../../Themes'
const propTypes = {
  links: PropTypes.array,
  logo: PropTypes.node,
  className: PropTypes.string
}

const Logo = styled.div`
  margin: ${Metrics.margins.large} 35px;
  overflow: hidden;
  img {
    width: 130px;
  }
`

const SidebarContainer = styled.div`
  height: 100vh;
  width: ${Metrics.components.sidebar};
  background: ${Colors.black}
  display: inline-block;
  color: white;
  margin: 0px;
`

const CustomLink = styled(Link)`
  ${Fonts.style.Text};
  color: ${Colors.white};
  text-decoration: none;
  display: block;
  padding: 20px;
  border-left: 8px solid transparent;
  ${props => props.isSubLink && `padding-left:${Metrics.margins.big}`};
  
  &.active {
    ${props => !props.isSubLink && `border-left: 8px solid ${Colors.white}`};
    ${props => !props.isSubLink && ` backgroundColor: ${Colors.whiteOverlay}`};
    ${props => props.isSubLink && ` color: ${Colors.primary}`};
  }

  &:hover {
    background: ${Colors.whiteOverlay};
  }
`

const LinksList = styled.ul`
  padding: 0;
  list-style: none;
`

const LinkContainer = styled.li`
  min-height: 54px;
  display: block;
  cursor: pointer;
`

const SubLinksContainer = styled.ul`
  height: 0;
  overflow: hidden;
  transition: height 0.5s ease;
  padding: 0;
  &.visible {
    transition: height 0.5s ease;
    height: ${props => (props.length ? `${54 * props.length}px` : '100%')};
  }
`

const Sidebar = props => {
  const { logo, links, className } = props
  const location = window.location.pathname

  const list = links.map((link, index) => {
    if (link.sublinks) {
      return (
        <LinkContainer key={`link-${index}`}>
          <CustomLink
            to={link.to}
            onClick={() =>
              document.getElementById(link.id).classList.toggle('visible')}
            className={`${location.indexOf(link.label.toLowerCase()) !== -1 &&
              'active'}`}>
            {link.label}
          </CustomLink>
          <SubLinksContainer id={link.id} length={link.sublinks.length}>
            {link.sublinks.map((sublink, idx) => {
              return (
                <LinkContainer key={`sublink-${idx}`}>
                  <CustomLink
                    isSubLink
                    to={sublink.to}
                    className={`${location.indexOf(
                      sublink.label.toLowerCase()
                    ) !== -1 && 'active'}`}>
                    {sublink.label}
                  </CustomLink>
                </LinkContainer>
              )
            })}
          </SubLinksContainer>
        </LinkContainer>
      )
    } else {
      return (
        <LinkContainer key={`link-${index}`}>
          <CustomLink
            key={`link-${index}`}
            to={link.to}
            className={`${location.indexOf(link.label.toLowerCase()) !== -1 &&
              'active'}`}>
            {link.label}
          </CustomLink>
        </LinkContainer>
      )
    }
  })

  return (
    <SidebarContainer className={className}>
      <Logo>{logo}</Logo>
      <LinksList>{list}</LinksList>
    </SidebarContainer>
  )
}

Sidebar.propTypes = propTypes

export default Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js